import React from "react"
import PropTypes from "prop-types"
import { createRef } from "react"
import hljs from "highlight.js/lib/common"
import "highlight.js/styles/sunburst.css"

import BlockRemove from "./BlockRemove"

export default class CodeBlock extends React.Component {

  blockRef = createRef(null);

  constructor (props) {
      super(props);
      this.state = {
        published: this.props.published || false,
        value: ""
      }

      this.TAB = 9;

      if (typeof this.props.code == "string" && this.props.code.length > 0) {

        this.state.value = this.props.code;
      }
  }

  indent (event) {

    const key = event.keyCode;

    if(key == this.TAB) {

        const value = event.target.value;
        const start = value.substring(0, event.target.selectionStart);
        const end = value.substring(event.target.selectionEnd);

        this.setState({value: start + "    " + end});
        event.target.selectionStart = start + 4;
        event.preventDefault();
    }
  }

  change (event) {
    this.setState({value: event.target.value});
  }

  highlightCode () {

    if (!this.state.published || !this.blockRef.current) {
      return;
    }

    if (this.blockRef.current.dataset.highlighted === "yes") {
      return;
    }

    hljs.highlightElement(this.blockRef.current);
  }

  /**
   * Highlights the code after the component has been mounted
   */
  componentDidMount () {

    this.highlightCode();
  }

  componentDidUpdate (prevProps, prevState) {

    if (prevState.value !== this.state.value && this.blockRef.current) {
      delete this.blockRef.current.dataset.highlighted;
    }

    this.highlightCode();
  }

  render () {

    const form = (
      <p className="code-block-form">
        <BlockRemove class="code-block-remove" clickHandler={this.props.removeCallback}/>
        <label>Source Code</label>
        <textarea rows="15"
                  onKeyDown={this.indent.bind(this)}
                  onChange={this.change.bind(this)}
                  value={this.state.value}
                  name={"article[blocks][" + this.props.order + "][code]"}>
        </textarea>
      </p>
    );

    const source = (
      <pre>
        <code ref={this.blockRef} className="hljs">
          {this.state.value}
        </code>
      </pre>
    );

    if(this.state.published) {
        return source;
    } else {
        return form;
    }
  }
}

CodeBlock.propTypes = {
  code: PropTypes.string,
};
